import { ICompteReturn} from './../../../models/interfaces/ICompte';
import { ServiceApplication_Key } from "../../../config/helpers";
import { apiSlice } from "../api";

export interface compteApiQueryBody {
  Application_Key: string;
  // eslint-disable-next-line
  Values: any;
}

export const compteApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchUserByLogin: builder.query<ICompteReturn, string>({ //iuser ??
      query: (login) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: { Login: login },
        };
        return {
          url: "/Authentification/Authentification_GetPersonneByLogin",
          method: "POST",
          body: body,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
   useLazyFetchUserByLoginQuery,
} = compteApi;
